// firebase.ts
import { initializeApp } from 'firebase/app';
import {
  signOut as firebaseSignOut,
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithPopup,
  User,
} from 'firebase/auth';

// Initialize Firebase
let app: any, auth: any;

export const initFirebase = (config: Json | string) => {
  if (typeof config === 'string') {
    config = JSON.parse(config);
  }

  app = initializeApp(config);
  auth = getAuth(app);
};

export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const credential = GoogleAuthProvider.credentialFromResult(result);
  const token = credential?.accessToken;
  const user = result.user;
  return { user, token };
};

export const signOut = async () => {
  await firebaseSignOut(auth);
  console.log('User signed out');
};

// Listen to auth state changes
export const onAuthChange = (callback: (user: User | null) => void) => {
  return onAuthStateChanged(auth, callback);
};
